// SIGNING DETAILS
export const GET_SIGNING_DETAILS = "GET_SIGNING_DETAILS";
export const GET_SIGNING_DETAILS_SUCCESS = "GET_SIGNING_DETAILS_SUCCESS";
export const GET_SIGNING_DETAILS_FAILURE = "GET_SIGNING_DETAILS_FAILURE";
export const GET_SIGNING_DETAILS_RESET = "GET_SIGNING_DETAILS_RESET";
